export default __webpack_public_path__ + "static/media/anthem-website-logos_mtv.d7f5ace1.webp";